import styled, { css } from 'styled-components'

// NOTE: component doesn't have a hover/active/disabled, etc...
// It's targeted for a single use case.
export const SwitchWrapper = styled.label(
  ({ theme }) => css`
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['2']};
    border-radius: ${theme.border.radius.full};
    padding: ${theme.space['2']};
    cursor: pointer;
    user-select: none;
    transition: background-color ${theme.transition.duration.md} ease;
    font-weight: 500;

    &[data-checked='false'] {
      background-color: ${theme.colors.gray300};

      > [data-type='falsy'] {
        color: ${theme.colors.primary800};
      }

      > [data-type='truthy'] {
        color: ${theme.colors.primary500};
      }
    }

    &[data-checked='true'] {
      background-color: ${theme.colors.blue500};

      > [data-type='falsy'] {
        color: ${theme.colors.white};
      }

      > [data-type='truthy'] {
        color: ${theme.colors.blue500};
      }
    }
  `,
)

export const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`

export const SwitchLabel = styled.span(
  ({ theme }) => css`
    min-width: 6.1rem;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.6rem;
    padding: ${theme.space['6']} ${theme.space['8']};
    border-radius: ${theme.border.radius.full};
    transition:
      background-color ${theme.transition.duration.md} ease,
      color ${theme.transition.duration.md} ease;
    white-space: nowrap;

    &[data-active='true'] {
      background: ${theme.colors.white};
    }
  `,
)
